
import SubHeader from "../components/SubHeader";
import "antd/dist/antd.css";
//RUN: new header component 16/04/2021
import HeaderComponent from "../components/HeaderComponent";
import LoginScreen from "./LoginScreen";
import { Redirect } from "react-router";
import "../shared/css/list-page.css";
import "../shared/css/headerpages.css";
import React, { useState, useEffect } from "react";
import { Drawer, Card, Table, Spin } from 'antd';
import * as _ from "lodash"; //
import moment from "moment";
const VaccineHome = () => {
  const [VachistoryInfo, setVacHistory] = useState([]);
  const [CovidDetectHistory, setCovidDetectHistory] = useState([]);


  const init = () => {
    fetch(process.env.REACT_APP_API_URL + "/api/getCovidHistory", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },

      body: JSON.stringify({
        empid: localStorage.getItem("EmpId"),
      }),
    }).then((Response) => Response.json())
      .then((result) => {
        console.log('ccdcdcdcdcd', result)

        console.log('result', `${result.covidHistory}`)
        setVacHistory(
          result[0].covidHistory
        )
        setCovidDetectHistory(
          result[0].covidDetectHistory
        )

      });
  };
  const columnsTH = [
    {
      title: localStorage.getItem('Language') == 'TH' ? 'เข็มที่' : 'Dose',
      dataIndex: 'Dose',
      width: '10%',
      className: 'reporthead reportcolumn reporttd'
    },
    {
      title: localStorage.getItem('Language') == 'TH' ? 'ชื่อวัคซีน' : 'Name of Vaccine',
      dataIndex: 'VacName',
      width: '10%',
      className: 'reporthead reportcolumn reporttd'

    },
    {
      title: localStorage.getItem('Language') == 'TH' ? 'วันที่ได้รับวัคซีน' : 'Date of Vaccination',
      // title: 'วันที่ได้รับวัคซีน / Date of Vaccination',
      dataIndex: 'VacDate',
      width: '10%',
      className: 'reporthead reportcolumn reporttd'
    },



  ];

  const tableDataTH = [];
  {
    if (VachistoryInfo) {
      VachistoryInfo.map((data, index) => {
        tableDataTH.push({
          key: index,
          Dose: data.Dose,
          VacName: data.VacID == 7 ? <div> {localStorage.getItem('Language') == 'TH' ? data.VacNameTH : data.VacNameEN} ({data.OtherVaccine}) </div> : <div> {localStorage.getItem('Language') == 'TH' ? data.VacNameTH : data.VacNameEN} </div>,
          VacDate: data.VacDate === null ? null : moment(data.VacDate).format("DD/MM/YYYY"),
        })
      })
    }

  }

  const columnsCovidDetctHistory = [
    {
      title: localStorage.getItem('Language') == 'TH' ? 'ครั้งที่' : 'No',
      // title: 'ครั้งที่ / No',
      dataIndex: 'DetectCount',
      width: '10%',
      className: 'reporthead reportcolumn reporttd'

    },
    {
      title: localStorage.getItem('Language') == 'TH' ? 'ประเภทการตรวจ' : 'Detection Type',
      // title: 'ผลการตรวจ ',
      dataIndex: 'Type',
      width: '10%',
      className: 'reporthead reportcolumn reporttd'

    },
    {
      title: localStorage.getItem('Language') == 'TH' ? 'วันที่ตรวจพบเชื้อ' : 'Date of detection',
      // title: 'วันที่ตรวจพบเชื้อ / Date of detection',
      dataIndex: 'DetectDate',
      width: '10%',
      className: 'reporthead reportcolumn reporttd'

    },
    {
      title: localStorage.getItem('Language') == 'TH' ? 'วันที่รักษาหาย' : 'Date of recovery',
      // 
      // title: 'วันที่รักษาหาย / Date of recovery',
      dataIndex: 'CuredDate',
      width: '10%',
      className: 'reporthead reportcolumn reporttd'

    },

  ];
  const tableDetectHistory = [];
  {
    if (CovidDetectHistory) {
      CovidDetectHistory.map((data, index) => {
        tableDetectHistory.push({
          key: index,
          DetectCount: data.DetectCount,
          Type: data.Type == 0 ? 'ATK' : 'RT-PCR',
          // VacDate: data.VacDate === null ? null : moment(data.VacDate).format("DD/MM/YYYY"),
          DetectDate: data.DetectDate === null ? null : moment(data.DetectDate).format("DD/MM/YYYY"),
          CuredDate: data.CuredDate === null ? null : moment(data.CuredDate).format("DD/MM/YYYY"),
        })
      })
    }

  }

  useEffect(() => {
    init();
  }, []);

  return (
    <div>
      <SubHeader />
      <div style={{ marginBlock: 15 }}>
        <div style={{ textAlign: 'center' }}>
        {localStorage.getItem('Language') == 'TH' ?
             <h2> สถานะการรับวัคซีน และ การตรวจพบการติดเชื้อ Covid-19 </h2>
              :
              <h3>Vaccine and Covid Detection History </h3>
            }

         
        </div>
        <div class="tab-centered tablelistpage" style={{ margin: 20 }}>
          <div style={{ marginLeft: 20 }}>
            {localStorage.getItem('Language') == 'TH' ?
              <h3>ประวัติการฉีดวัคซีนโควิด-19</h3>
              :
              <h3>History of COViD-19 Vaccination</h3>
            }

          </div>
          <Table
            columns={columnsTH}
            dataSource={tableDataTH}
            pagination={false}
          />
        </div>
        <div class="tab-centered tablelistpage" style={{ margin: 20 }}>
          <div style={{ marginLeft: 20 }}>
            {localStorage.getItem('Language') == 'TH' ?
              <h3>ผลการตรวจโควิด-19</h3>
              :
              <h3>COVID-19 test result(s)</h3>
            }

          </div>
          <Table
            columns={columnsCovidDetctHistory}
            dataSource={tableDetectHistory}
            pagination={false}
          />
        </div>
      </div>
    </div>
  )
}

export default VaccineHome
